import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import './InquiryComplete.scss';

// 신청서(/inquiry) 제출 직후 이동하는 완료 화면.
const InquiryComplete = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="inquiry-complete-page">
      <Header />
      <section className="inquiry-success">
        <div className="inquiry-success__inner">
          <div className="inquiry-success__icon" aria-hidden="true" />
          <h1 className="inquiry-success__title">앱제작신청이 접수되었습니다.</h1>
          <p className="inquiry-success__desc">
            담당자 확인 후 기본요금 결제 안내를 드리며, 결제가 완료되면 MVP 제작이
            시작됩니다. 이후 단계는 등록하신 담당자 성함과 연락처로 조회해 이어서
            진행할 수 있습니다.
          </p>
          <Link to="/" className="inquiry-success__button">
            홈으로
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default InquiryComplete;
